define(["jquery", "mustache", "history"], function ($, mustache) {
    var originalTitle = document.title;
    var trusteesFilter = {

        $resultsContainer: $("#filter-results"),
        init: function () {
            if (window.History.enabled) {
                $("#filter input[type=submit]").hide();

                //Fix för att första sidladdningen utan KOMPLETT querystring blir en dubblett i history-listan, och därmed failar hela history-hanteringen.
                //Denna rad måste stå före initializeHistoryStuff(), annars funkar det inte i Chrome!
                trusteesFilter.UpdateHistory(true);

                trusteesFilter.InitializeHistoryStuff();
            }
        },
        InitializeHistoryStuff: function () {
            // SELECT ON-CHANGE
            $("#board").change(function () {
                trusteesFilter.UpdateHistory(false);
            });

            // SELECT ON-CHANGE
            $("#party").change(function () {
                trusteesFilter.UpdateHistory(false);
            });

            // INPUT ON-KEYUP
            var timer;
            $("#q").keyup(function () {
                var delay = 500;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    trusteesFilter.UpdateHistory(false);
                }, delay);
            });

            History.Adapter.bind(window, "statechange", function () {
                var state = window.History.getState();

                //Uppdatera inmatningsfälten
                trusteesFilter.UpdateInputFields(state);

                //Uppdatera resultatlistan
                trusteesFilter.UpdateResultList(state);
            });
        },
        GetQueryStringPart: function (url, key) {
            var vars = [], hash;

            var questionmarkIndex = url.indexOf("?");
            if (questionmarkIndex == -1) return "";

            var queryString = url.slice(questionmarkIndex + 1);

            var hashes = queryString.split("&");

            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split("=");
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }

            if (!vars.hasOwnProperty(key)) {
                return "";
            }

            return vars[key];
        },

        GetSortFromQueryString: function () {
            var sort;
            var querySort = trusteesFilter.GetQueryStringPart(window.location.search, "sort");
            if (querySort == "")
                return "";

            var hashSort = querySort.indexOf("#");
            if (hashSort > 0) {
                querySort = querySort.substring(0, hashSort);
            }
            if (querySort.indexOf("Assignment") > -1 && $("#board").val() == "") {
                sort = "";
            }
            else {
                sort = querySort;
            }

            return sort;
        },

        //Pushes the "filter input control state" into history
        UpdateHistory: function (isInitial) {
            var query = $("#q").val();
            var board = $("#board").val();
            var party = $("#party").val();
            var sort = trusteesFilter.GetSortFromQueryString();
            var page = isInitial ? trusteesFilter.GetQueryStringPart(window.location.search, "page") : "";
            var history = window.History;
            var state = history.getState();

            state.title = query ? query + ' - ' + originalTitle : originalTitle; 

            var hash = window.location.hash;

            if (hash !== "") {
                var scrollPos = trusteesFilter.$resultsContainer.offset().top;
                $(window).scrollTop(scrollPos);
            }

            var queryString = "?q=" + encodeURIComponent(query) + "&board=" + encodeURIComponent(board) + "&party=" + encodeURIComponent(party) + "&sort=" + encodeURIComponent(sort) + "&page=" + encodeURIComponent(page);
            if (isInitial) {
                //Ser till att querystring är komplett vid första första sidladdningen och gör sedan replace på history entryt.
                document.title = state.title;
                history.replaceState({
                    state: { query: query, board: board, party: party, sort: sort, page: page }
                }, state.title, queryString);
            } else {
                history.pushState({
                    state: { query: query, board: board, party: party, sort: sort, page: page }
                }, state.title, queryString);
            }
        },
        //UPDATE HTML FOR INPUT FIELDS
        UpdateInputFields: function (historyState) {
            if (historyState.data != null) {
                if (historyState.data.state.query != null) {
                    $("#q").val(historyState.data.state.query);
                }
                else {
                    $("#q").val("");
                }
                if (historyState.data.state.board != null) {
                    $('#board option[value="' + historyState.data.state.board + '"]').prop("selected", true);
                }
                else {
                    $('#board option[value="' + "" + '"]').prop("selected", true);
                }

                if (historyState.data.state.party != null) {
                    $('#party option[value="' + historyState.data.state.party + '"]').prop("selected", true);
                }
                else {
                    $('#party option[value="' + "" + '"]').prop("selected", true);
                }
            }
        },

        //GET ResultList HTML AND UPDATE HTML
        UpdateResultList: function (historyState) {
            var historyBaseUrl = historyState.url;
            var historyQueryString = "";
            var questionmarkIndex = historyState.url.indexOf("?");

            if (questionmarkIndex > -1) {
                historyBaseUrl = historyBaseUrl.substring(0, questionmarkIndex);
                historyQueryString = historyState.url.slice(questionmarkIndex + 1);

                //Fix för att "lura" history-listan i IE och Chrome som cache:ar entrys,
                //vilket gör att ajax-anropens fejkade entrys blir korrupta. Genom att
                //ge ajax-anropen en url som skiljer sig från de vanliga anropen lurar
                //vi history-cachen att cache:a på rätt sätt.
                historyQueryString = "ajax=1&" + historyQueryString;
            }

            $.ajax({
                url: historyBaseUrl,
                type: "get",
                data: historyQueryString,
                success: function (response) {
                    var resultList = $("#result-list");
                    var filterSummary = $("#filter-summary");
                    var paging = $("#paging");

                    // HITS
                    var hitsTemplate =
                        "{{#Hits}}" +
                        "<li>" +
                        '<div class="person">' +
                        '<h3><a href="{{PersonPageUrl}}">{{FullName}} ({{Party.PartyCode}})</a></h3>' +
                        "{{#Title}}<span>{{Title}}</span>{{/Title}}" +
                        "</div>" +
                        "{{#ProfileImageUrl}}" +
                        '<div class="photo">' +
                        "<figure>" +
                        '<img src="{{ProfileImageUrl}}" alt="{{FullName}}" />' +
                        "</figure>" +
                        "</div>" +
                        "{{/ProfileImageUrl}}" +
                        "</li>" +
                        "{{/Hits}}";
                    var hitsHtml = mustache.render(hitsTemplate, response.Politicians);
                    resultList.html(hitsHtml);

                    // FILTER SUMMARY
                    var summaryTemplate =
                        "{{#HasPaging}}" +
                        '<div id="hidden-list-label" class="visuallyhidden">Lista med förtroendevalda sida {{Politicians.PageNumber}}</div>' +
                        "{{/HasPaging}}" +
                        "{{^HasPaging}}" +
                        '<div id="hidden-list-label" class="visuallyhidden">Lista med förtroendevalda</div>' +
                        "{{/HasPaging}}" +
                        '<div class="hit-count"><div class="wrapper"><div class="hits"><span class="count">' +
                        "{{HitCount}}" +
                        "</span></div>" + " " +
                        '<div class="hitmodifier">' +
                        "<strong>" +
                        "{{HitCountText}}" +
                        "</strong>" +
                        "{{#FormFilterCollection.ActiveFilters}} " +
                        '{{Preposition}} <span class="filter-remove-button"><strong>{{Value}}&nbsp;</strong><a role="button" href="{{RemoveFilterUrl}}" title="{{RemoveFilterText}} {{Value}}" aria-label="{{RemoveFilterText}} {{Value}}">&times;</a></span>' +
                        "{{/FormFilterCollection.ActiveFilters}}" +
                        "</div>" +
                        "</div>" +
                        "</div>" +
                        "{{#BoardMembersAndVacancies.VacanciesText}}" +
                        '<p class="vacancies-text">{{BoardMembersAndVacancies.VacanciesText}}</p>' +
                        "{{/BoardMembersAndVacancies.VacanciesText}}" +
                        '<div id="sort-filter">' +
                        "<span>{{SortLabel}} </span>" +
                        "<ul>" +
                        "{{#SortOrderOptions}}" +
                        "<li>" +
                        "{{#Active}} <span>{{Name}}</span>{{/Active}}" +
                        '{{^Active}} <a href="{{Url}}">{{Name}}</a>{{/Active}}' +
                        "</li>" +
                        "{{/SortOrderOptions}}" +
                        "</ul>" +
                        "</div>";
                    var summaryHtml = mustache.render(summaryTemplate, response);
                    filterSummary.html(summaryHtml);

                    // PAGING
                    var pagingTemplate =
                        "{{#HasPaging}}" +
                        '<div id="size-picker"><a href="{{ShowAll}}">Visa alla</a></div>' +
                        "{{#Politicians.HasPreviousPage}}" +
                        '<a id="previous" href="{{PrevoiusPage}}">' +
                        "<span>Föregående</span>" +
                        '<span class="paging-info">{{Politicians.PreviusPageNumber}} av {{Politicians.PageCount}}</span>' +
                        "</a>" +
                        "{{/Politicians.HasPreviousPage}}" +
                        "{{#Politicians.HasNextPage}}" +
                        '<a id="next" href="{{NextPage}}">' +
                        "<span>Nästa</span>" +
                        '<span class="paging-info">{{Politicians.NextPageNumber}} av {{Politicians.PageCount}}</span>' +
                        "</a>" +
                        "{{/Politicians.HasNextPage}}" +
                        "{{/HasPaging}}";
                    var pagingHtml = mustache.render(pagingTemplate, response);
                    paging.html(pagingHtml);
                }
            });
        }

    }
    return trusteesFilter;
});